import { createFileRoute } from '@tanstack/react-router'
import { RolesTable } from '../../../../modules/settings/roles-table'
import { SettingsShell } from '../../../../modules/settings/settings-shell'

export const Route = createFileRoute('/_authed/settings/general/roles')({
  component: () => (
    <SettingsShell>
      <RolesTable />
    </SettingsShell>
  ),
})
